const handleLoader = (dispatch, payload) => {
  dispatch({ type: 'LOADER', payload });
};
const handleSetOptionsData = (dispatch, payload) => {
  dispatch({ type: 'SET_OPTIONS_DATA', payload });
};
const handleSetTicketsData = (dispatch, payload) => {
  dispatch({ type: 'SET_TICKETS_DATA', payload });
};
const handleSetFaqData = (dispatch, payload) => {
  dispatch({ type: 'SET_FAQ_DATA', payload });
};
const handleSetCsPortalData = (dispatch, payload) => {
  dispatch({ type: 'SET_CSPORTAL_DATA', payload });
};
const handleAlertSnackbar = (dispatch, payload) => {
  dispatch({ type: 'ALERT_SNACKBAR', payload });
};
const handlePopup = (dispatch, payload) => {
  dispatch({ type: 'SET_POPUP', payload });
};
const handleSetBannerTypeData = (dispatch, payload) => {
  dispatch({ type: 'SET_BANNER_TYPE_DATA', payload });
};
const handleLoginPopup = (dispatch, payload) => {
  dispatch({ type: 'LOGIN_POPUP', payload });
};
const handleFaqChange = (dispatch, payload) => {
  dispatch({ type: 'FAQ_CHANGE', payload });
};
const handleValidatorPopup = (dispatch, payload) => {
  dispatch({ type: 'VALIDATOR_POPUP', payload });
};
const handleShowTagsFeedback = (dispatch, payload) => {
  dispatch({ type: 'SHOW_FEEDBACK_PAGE', payload });
};
export {
  handleLoader,
  handleSetTicketsData,
  handleSetFaqData,
  handleSetOptionsData,
  handleSetCsPortalData,
  handleAlertSnackbar,
  handlePopup,
  handleSetBannerTypeData,
  handleLoginPopup,
  handleFaqChange,
  handleValidatorPopup,
  handleShowTagsFeedback,
};
